import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import HomeVideo2 from '../assets/images/banner/about.mp4';

const partnerLogos = [
    require('../assets/images/partner/partner-1.webp'),
    require('../assets/images/partner/partner-2.webp'),
    require('../assets/images/partner/partner-3.webp'),
    require('../assets/images/partner/partner-4.webp'),
    require('../assets/images/partner/partner-5.webp'),
    require('../assets/images/partner/partner-6.webp'),
    require('../assets/images/partner/partner-7.webp'),
    require('../assets/images/partner/partner-8.webp'),
    require('../assets/images/partner/partner-9.webp'),
    require('../assets/images/partner/partner-10.webp'),
    require('../assets/images/partner/partner-11.webp'),
    require('../assets/images/partner/partner-12.webp'),
    require('../assets/images/partner/partner-13.webp'),
    require('../assets/images/partner/partner-14.webp'),
    require('../assets/images/partner/partner-15.webp'),
    require('../assets/images/partner/partner-16.webp'),
    require('../assets/images/partner/netskope.png'),
];

const testimonials = [
    {
        quote: "CLOUD MIND has been a game changer for our cybersecurity strategy. Their comprehensive protection across our email, cloud, and network systems has kept our data secure from evolving threats.",
        name: "IT Director",
        role: "Manufacturing Industry",
        initial: "I",
    },
    {
        quote: "We turned to CLOUD MIND for a complete overhaul of our cybersecurity protocols, and it was the best decision we made. Their expert team implemented robust security measures making us feel protected.",
        name: "Chief Information Security Officer",
        role: "Manufacturing Industry",
        initial: "C",
    },
    {
        quote: "CLOUD MIND's email security and network defense solutions have been critical in preventing cyber threats. We've seen a significant reduction in phishing attempts and other security breaches.",
        name: "Operations Manager",
        role: "Agriculture Industry",
        initial: "O",
    },
    {
        quote: "Since partnering with CLOUD MIND, our network and cloud systems have been fortified with state-of-the-art security protocols, ensuring compliance and protecting our clients' data.",
        name: "Founder",
        role: "Healthcare Industry",
        initial: "F",
    },
    {
        quote: "CLOUD MIND has delivered unmatched expertise in securing our cloud services and networks. Their end-to-end solutions have helped us prevent data breaches and avoid costly downtime.",
        name: "Chief Technology Officer",
        role: "Real Estate Industry",
        initial: "C",
    },
    {
        quote: "The cybersecurity solutions provided by CLOUD MIND have given us a level of confidence we didn't have before. Their services cover everything from email threat prevention to cloud and network security.",
        name: "Head of Technology",
        role: "Transportation Industry",
        initial: "H",
    },
];

export default function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* ── Hero Banner ── */}
            <section className="about-hero">
                <video autoPlay loop muted className="about-hero-video">
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
                <div className="about-hero-overlay"></div>
                <div className="container about-hero-content">
                    <div className="about-hero-breadcrumb">
                        <Link to="/">Home</Link>
                        <i className="fa fa-chevron-right"></i>
                        <span>About Us</span>
                    </div>
                    <div className="about-hero-badge">
                        <span className="banner-badge-dot"></span>
                        Leading Cybersecurity Solutions Provider
                    </div>
                    <h1 className="about-hero-title">
                        Protecting What <span className="banner-highlight">Matters Most</span>
                    </h1>
                    <p className="about-hero-sub">
                        Delivering advanced cyber security solutions through global technology partnerships - securing Enterprise, Government &amp; SMB businesses across the region.
                    </p>
                    <div className="banner-cta-row">
                        <Link to="/contact"><button className="banner-btn-primary">Get in Touch <i className="fa fa-arrow-right"></i></button></Link>
                        <Link to="/partners"><button className="banner-btn-secondary">Our Partners</button></Link>
                    </div>
                </div>
            </section>

            {/* ── Stats Bar ── */}
            <div className="about-stats-bar">
                <div className="container">
                    <div className="about-stats-grid">
                        {[
                            { num: '8+', label: 'Years Experience' },
                            { num: '200+', label: 'Clients Protected' },
                            { num: '50+', label: 'Technology Partners' },
                            { num: '24/7', label: 'SOC Monitoring' },
                        ].map((s, i) => (
                            <div className="about-stat-item" key={i}>
                                <div className="about-stat-num">{s.num}</div>
                                <div className="about-stat-label">{s.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── About Company ── */}
            <section className="about-company-section top bottom">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="about-img-stack">
                                <img src={require('../assets/images/about1.webp')} alt="Cloud Mind" className="about-img-main" />
                                <img src={require('../assets/images/compnay/about-hack.webp')} alt="Cybersecurity" className="about-img-secondary" />
                                <div className="about-exp-badge">
                                    <span className="about-exp-num">8+</span>
                                    <span className="about-exp-text">Years<br />Experience</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-company-content">
                                <div className="content-badge mb-3">
                                    <span className="badge-text">About Company</span>
                                </div>
                                <h2 className="section-main-heading text-white mb-4">
                                    Who We <span className="banner-highlight">Are</span>
                                </h2>
                                <p className="para_text3 mb-3">
                                    CLOUD MIND is one of the leading solution providers in the region with a customer-centric approach. We deliver advanced cyber security solutions through partnerships with global technology vendors - protecting Enterprise, Government and SMB businesses.
                                </p>
                                <p className="para_text3 mb-4">
                                    With exceptional technical knowledge, our expertise designs and executes projects in the most effective and efficient manner - empowering businesses by eliminating risk and streamlining operations.
                                </p>
                                <div className="about-highlights">
                                    {[
                                        { icon: 'fa-shield-alt', text: 'End-to-End Security Solutions' },
                                        { icon: 'fa-handshake', text: 'Global Technology Partnerships' },
                                        { icon: 'fa-users', text: 'Customer-Centric Approach' },
                                        { icon: 'fa-clock', text: '24/7 Managed SOC Services' },
                                    ].map((h, i) => (
                                        <div className="about-highlight-item" key={i}>
                                            <div className="about-highlight-icon"><i className={`fa ${h.icon}`}></i></div>
                                            <span>{h.text}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="button_call mt-4">
                                    <Link to="/contact"><button>Work With Us <i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Why Choose Us ── */}
            <div className="about-why-section top bottom">
                <div className="container">
                    <div className="sub-heading-text mb-5">
                        <h2 className="text-center text-white">Why Choose Cloud Mind</h2>
                        <div className="divider-wrapper small"></div>
                    </div>
                    <div className="row g-4">
                        {[
                            { icon: 'fa-users', title: 'Employee Growth', text: 'We invest in ongoing training, certifications, and the latest tools ensuring our team is always at the industry forefront.' },
                            { icon: 'fa-lightbulb', title: 'Culture of Excellence', text: 'Innovation, teamwork, and continuous learning are celebrated. Our inclusive environment empowers employees to thrive.' },
                            { icon: 'fa-lock', title: 'Tangible Impact', text: "Our solutions directly influence the safety of clients' digital infrastructure, mitigating risks and protecting sensitive data." },
                            { icon: 'fa-project-diagram', title: 'Collaborative Approach', text: 'We work alongside industry experts, exchanging ideas to create innovative solutions for the evolving cybersecurity landscape.' },
                        ].map((w, i) => (
                            <div className="col-lg-3 col-md-6" key={i}>
                                <div className="about-why-card">
                                    <div className="about-why-icon"><i className={`fa ${w.icon}`}></i></div>
                                    <h4>{w.title}</h4>
                                    <p>{w.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Mission & Vision ── */}
            <section className="about-mv-section top bottom">
                <div className="container">
                    <div className="sub-heading-text mb-5">
                        <h2 className="text-center text-white">Our Mission &amp; Vision</h2>
                        <div className="divider-wrapper small"></div>
                    </div>
                    <div className="row g-4 justify-content-center">
                        <div className="col-lg-6">
                            <div className="about-mv-card">
                                <div className="about-mv-icon">
                                    <i className="fa fa-bullseye"></i>
                                </div>
                                <div className="about-mv-body">
                                    <h3>Our Mission</h3>
                                    <p>Ensuring a healthy cyber ecosystem - empowering security professionals to address compliance and simplify cyber threat management, bringing greater value and protection to organizations worldwide.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-mv-card">
                                <div className="about-mv-icon vision">
                                    <i className="fa fa-eye"></i>
                                </div>
                                <div className="about-mv-body">
                                    <h3>Our Vision</h3>
                                    <p>To be the leader in cloud and cyber security - protecting the digital workforce of organizations and addressing global cybersecurity challenges across borders with innovation and expertise.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Core Values ── */}
            <div className="about-values-section top bottom">
                <div className="container">
                    <div className="sub-heading-text mb-5">
                        <h2 className="text-center text-white">Our Core Values</h2>
                        <div className="divider-wrapper small"></div>
                    </div>
                    <div className="row g-4">
                        {[
                            { icon: 'fa-fist-raised', title: 'Solving Big Problems', text: 'We love tough challenges and always reach for ambitious goals, tackling them with innovative ideas and tenacity.' },
                            { icon: 'fa-heart', title: 'Passion for Customers', text: 'We love helping protect our customers by bringing deep expertise, experience and thoughtful partnerships.' },
                            { icon: 'fa-star', title: 'Strive for Excellence', text: 'We hold exceptionally high standards, are outcome-driven, and never stop focusing on continuous improvements.' },
                            { icon: 'fa-users', title: 'We are a Team', text: "Respect and trust of each other's unique experiences are the foundations of great teams - we foster openness and transparency." },
                        ].map((v, i) => (
                            <div className="col-lg-3 col-md-6" key={i}>
                                <div className="about-value-card">
                                    <div className="about-value-icon-wrap">
                                        <i className={`fa ${v.icon}`}></i>
                                    </div>
                                    <h4>{v.title}</h4>
                                    <p>{v.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Technology Partners Slider ── */}
            <section className="about-partners-section top bottom">
                <div className="container">
                    <div className="sub-heading-text mb-5">
                        <h2 className="text-center text-white">Our Technology Partners</h2>
                        <div className="divider-wrapper small"></div>
                        <p className="text-center about-section-sub">Trusted partnerships with world-class technology vendors to deliver best-in-class cybersecurity solutions.</p>
                    </div>
                </div>
                <div className="about-partners-track-wrap">
                    <Swiper
                        slidesPerView={2.5}
                        spaceBetween={0}
                        loop={true}
                        speed={3500}
                        autoplay={{ delay: 0, disableOnInteraction: false }}
                        breakpoints={{
                            480: { slidesPerView: 3 },
                            768: { slidesPerView: 4 },
                            1024: { slidesPerView: 5 },
                            1280: { slidesPerView: 6 },
                        }}
                        modules={[Autoplay]}
                        className="about-partners-swiper"
                    >
                        {[...partnerLogos, ...partnerLogos].map((logo, i) => (
                            <SwiperSlide key={i}>
                                <div className="about-partner-logo-wrap">
                                    <img src={logo} alt={`partner-${i}`} />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>

            {/* ── Testimonials Slider ── */}
            <section className="about-testimonials-section top bottom">
                <div className="container">
                    <div className="sub-heading-text mb-2">
                        <h2 className="text-center text-white">What Our Clients Say</h2>
                        <div className="divider-wrapper small"></div>
                        <p className="text-center about-section-sub">Real feedback from businesses we protect every day.</p>
                    </div>

                    {/* large quote bg */}
                    <div className="about-testi-quote-bg">"</div>

                    <Swiper
                        spaceBetween={28}
                        loop={true}
                        autoplay={{ delay: 3500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                        breakpoints={{
                            0: { slidesPerView: 1, spaceBetween: 16 },
                            640: { slidesPerView: 1, spaceBetween: 20 },
                            768: { slidesPerView: 2, spaceBetween: 24 },
                            1024: { slidesPerView: 2, spaceBetween: 28 },
                            1440: { slidesPerView: 3, spaceBetween: 28 },
                        }}
                        modules={[Autoplay, Pagination]}
                        className="about-testi-swiper"
                    >
                        {testimonials.map((t, i) => (
                            <SwiperSlide key={i}>
                                <div className="about-testi-card">
                                    <div className="about-testi-stars">
                                        {[...Array(5)].map((_, si) => (
                                            <i key={si} className="fa fa-star"></i>
                                        ))}
                                    </div>
                                    <p className="about-testi-quote">"{t.quote}"</p>
                                    <div className="about-testi-footer">
                                        <div className="about-testi-avatar">{t.initial}</div>
                                        <div>
                                            <h6 className="about-testi-name">{t.name}</h6>
                                            <span className="about-testi-role">{t.role}</span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </>
    )
}
